import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ContributingCommitteeItem {
  CommitteeId: string; // Adjust the type as needed
  canComment?: boolean;
  mustVote?: boolean;
  canVote?: boolean;
}
interface CreateStandardData {
  id: string;
  activeStep: number;
  basicDetail: Record<string, any>;
  otherConfiguration: Record<string, any>;
  contributingCommittee: ContributingCommitteeItem[];
  staffNotes: Record<string, any>;
  withdrawalStandardRecords: any[];
  loading: boolean;
  isStandardSuccessfullyWithdrawn?: boolean;
  cannotWithdrawStandardId?: string; // Flag to indicate if the standard cannot be withdrawn
}
const initialState: CreateStandardData = {
  id: "",
  activeStep: 0,
  basicDetail: {},
  otherConfiguration: {},
  contributingCommittee: [],
  staffNotes: [],
  withdrawalStandardRecords: [],
  loading: false,
  isStandardSuccessfullyWithdrawn: false,
  cannotWithdrawStandardId: "",
};

const recordStandardSlice = createSlice({
  name: "Standard",
  initialState,
  reducers: {
    createBasicDetail: (state, action: PayloadAction<Record<string, any>>) => {
      state.basicDetail = { ...state.basicDetail, ...action.payload };
      state.loading = false;
    },
    createOtherRequest: (state, action: PayloadAction<Record<string, any>>) => {
      state.otherConfiguration = {
        ...state.otherConfiguration,
        ...action.payload,
      };
      state.loading = false;
    },
    createStaffDetail: (state, action: PayloadAction<Record<string, any>>) => {
      state.staffNotes = action.payload;
      state.loading = false;
    },
    setStandarRecorddId: (state, action: PayloadAction<string>) => {
      state.id = action.payload; // Update the id in the state
    },
    setActiveStep: (state, action: PayloadAction<number>) => {
      state.activeStep = action.payload; // Update the id in the state
    },
    setWithdrawalStandardRecords: (state, action: PayloadAction<any[]>) => {
      state.withdrawalStandardRecords = action.payload;
    },
    setStandardSuccessfullyWithdrawn: (state, action: PayloadAction<boolean>) => {
      state.isStandardSuccessfullyWithdrawn = action.payload;
    },
    setCannotWithdrawStandardId: (state, action: PayloadAction<string | "">) => {
      state.cannotWithdrawStandardId = action.payload;
    },
    setContributionCommitteeId: (
      state,
      action: PayloadAction<ContributingCommitteeItem[]>
    ) => {
      state.contributingCommittee = action.payload; // Update the contributionCommitteeId
    },
    resetBasicDetails: (state) => {
      state.basicDetail = {};
    },
    resetOtherDetails: (state) => {
      state.otherConfiguration = {};
    },
    resetContributeDetails: (state) => {
      state.contributingCommittee = [];
    },
    reset: () => initialState,
  },
});

export const {
  createBasicDetail,
  createOtherRequest,
  setStandarRecorddId,
  setContributionCommitteeId,
  createStaffDetail,
  resetBasicDetails,
  resetOtherDetails,
  resetContributeDetails,
  setActiveStep,
  setStandardSuccessfullyWithdrawn,
  setWithdrawalStandardRecords,
  setCannotWithdrawStandardId,
  reset,
} = recordStandardSlice.actions;
export default recordStandardSlice.reducer;
